var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2E3438",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.89 22.5C13.2935 22.4995 12.7216 22.2621 12.3 21.84L2.16 11.7075C1.73792 11.2859 1.50053 10.714 1.5 10.1175V3.75C1.5 2.50736 2.50736 1.5 3.75 1.5H10.1175C10.714 1.50053 11.2859 1.73792 11.7075 2.16L21.84 12.2925C22.2636 12.7147 22.5018 13.2882 22.5018 13.8863C22.5018 14.4843 22.2636 15.0578 21.84 15.48L15.48 21.84C15.0584 22.2621 14.4865 22.4995 13.89 22.5ZM6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9ZM7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9ZM3 3.75C3 3.33579 3.33579 3 3.75 3H10.1175C10.3179 3.00083 10.5097 3.08186 10.65 3.225L20.7825 13.3575C21.0733 13.65 21.0733 14.1225 20.7825 14.415L14.415 20.7825C14.1225 21.0733 13.65 21.0733 13.3575 20.7825L3.225 10.65C3.08186 10.5097 3.00083 10.3179 3 10.1175V3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.0a67b41168c0f2658b149d18a5283307.svg";
export { ForwardRef as ReactComponent };